let menu={
    state:{
        list:[
           
        ]
    },
    mutations:{
        initdata(state,data){
            state.list=data;
        }
     }
}
export default menu


// WEBPACK FOOTER //
// ./src/store/menu.js